class EnhancedKadesoSubscription {
  constructor() {
    this.addCustomStyles();
    this.hideStandardProductControls();

    window.kadesoInitializing = true;
    window.kadesoAttempts = (window.kadesoAttempts || 0) + 1;
    
    this.timeouts = [];
    this.initialized = false;
    // willow
    //this.mode = "subscription";
    this.mode = "onetime";
    this.productData = null;
    this.currentLanguage = this.detectLanguage();

    this.failsafeInitTime = Date.now();
    this.maxInitTime = 5000;

    this.setupLanguageChangeListener();

    this.perDayText = this.currentLanguage === "english" ? "/ day" : "/ dag";
    
    this.sellingPlans = {
      monthly: {
        id: null,
        discount_type: null,
        discount: null,
        price: null,
        name:
          this.currentLanguage === "english"
            ? "1-month supply"
            : "1-maand voorraad",
      },
      quarterly: {
        id: null,
        discount_type: null,
        discount: null,
        price: null,
        name:
          this.currentLanguage === "english"
            ? "3-months supply"
            : "3-maanden voorraad",
      },
      biannually: {
        id: null,
        discount_type: null,
        discount: null,
        name:
          this.currentLanguage === "english"
            ? "6-months supply"
            : "6-maanden voorraad",
      },
    };

    this.variants = {
      monthly: {
        id: null,
        price: null,
        title: null,
        available: false,
        metafields: null,
      },
      quarterly: {
        id: null,
        price: null,
        title: null,
        available: false,
        metafields: null,
      },
      biannually: {
        id: null,
        price: null,
        title: null,
        available: false,
        metafields: null,
      },
      monthlyOnetime: {
        id: null,
        price: null,
        compareAtPrice: null,
        title: null,
        available: false,
        metafields: null,
      },
      quarterlyOnetime: {
        id: null,
        price: null,
        compareAtPrice: null,
        title: null,
        available: false,
        metafields: null,
      },
      biannuallyOnetime: {
        id: null,
        price: null,
        compareAtPrice: null,
        title: null,
        available: false,
        metafields: null,
      }
    };

    this.prices = {};

    this.findElements();

    if (!this.placeholder || !this.subscriptionBlock) {
      this.scheduleElementRetry();
      return;
    }

    this.placeholder.innerHTML =
      '<div class="kadeso-loading">Loading product data...</div>';

    this.runInitSequence();

    this.watchdog = setTimeout(() => {
      if (!this.initialized) {
        this.forceInitialize();
      }
    }, this.maxInitTime);

    this.timeouts.push(this.watchdog);
  }

  findElements() {
    this.subscriptionBlock = document.querySelector(".subscription-block");
    this.placeholder = document.querySelector(
      ".kadeso-subscription-placeholder"
    );
    this.originalForm =
      document.querySelector('product-form form[action*="/cart/add"]') ||
      document.querySelector('form[action*="/cart/add"]');
    this.addToCartButton =
      this.originalForm?.querySelector('[type="submit"]') ||
      document.querySelector("[data-btn-addtocart]") ||
      this.originalForm?.querySelector('button[name="add"]');
    this.variantIdInput = this.originalForm?.querySelector('input[name="id"]');
    this.sealContainer = document.querySelector(".sealsubs-container");
    this.sellingPlanInput =
      document.querySelector('input[name="selling_plan"]') ||
      document.querySelector("input[data-sls-selling_plan]");
  }

  scheduleElementRetry() {
    if (window.kadesoAttempts > 10) {
      console.error(
        "KadesoSubscription: Too many initialization attempts, giving up"
      );
      return;
    }

    const retryTimeout = setTimeout(() => {
      this.findElements();
      if (this.placeholder && this.subscriptionBlock) {
        this.placeholder.innerHTML =
          '<div class="kadeso-loading">Loading product data...</div>';
        this.runInitSequence();
      } else {
        this.scheduleElementRetry();
      }
    }, 200);

    this.timeouts.push(retryTimeout);
  }

  runInitSequence() {
    Promise.all([this.loadProductData(), this.preloadSealData()])
      .then(([productSuccess, _]) => {
        if (productSuccess) {
          this.eagerInit();
        } else {
          this.fallbackLoadProduct().then((success) => {
            if (success) {
              this.eagerInit();
            } else if (this.placeholder) {
              this.placeholder.innerHTML =
                '<p class="kadeso-error">Failed to load essential product data.</p>';
            }
          });
        }
      })
      .catch((_) => {
        this.fallbackLoadProduct().then((success) => {
          if (success) {
            this.eagerInit();
          } else if (this.placeholder) {
            this.placeholder.innerHTML =
              '<p class="kadeso-error">An error occurred loading product data.</p>';
          }
        });
      });
  }

  async fallbackLoadProduct() {
    try {
      console.log('window.product = ', window.product);
      if (window.product && window.product.variants) {
        console.log('window.product = ', window.product);
        this.productData = window.product;
        this.extractVariantData();
        return true;
      }

      const scripts = document.querySelectorAll("script");
      for (const script of scripts) {
        if (!script.textContent) continue;

        const content = script.textContent.trim();
        if (content.includes('"variants":') && content.includes('"price":')) {
          try {
            const productJson = JSON.parse(content);
            if (
              productJson &&
              typeof productJson === "object" &&
              productJson.variants &&
              Array.isArray(productJson.variants) &&
              productJson.variants.length > 0
            ) {
              this.productData = productJson;
              this.extractVariantData();
              return true;
            }
          } catch (e) {}
        }
      }

      const jsonLdScripts = document.querySelectorAll(
        'script[type="application/ld+json"]'
      );
      for (const jsonLd of jsonLdScripts) {
        try {
          const data = JSON.parse(jsonLd.textContent);
          if (data["@type"] === "Product" && data.offers) {
            const simplifiedProduct = {
              id: data.productID || Math.floor(Math.random() * 1000000),
              variants: [],
            };

            if (Array.isArray(data.offers)) {
              data.offers.forEach((offer, index) => {
                simplifiedProduct.variants.push({
                  id: offer.sku || index + 1000,
                  price: parseFloat(offer.price) * 100,
                  compare_at_price: parseFloat(offer.highPrice) * 100,
                  title: offer.name || "Option " + (index + 1),
                  available:
                    offer.availability === "https://schema.org/InStock",
                });
              });
            } else if (data.offers) {
              simplifiedProduct.variants.push({
                id: data.offers.sku || 1000,
                price: parseFloat(data.offers.price) * 100,
                compare_at_price: parseFloat(data.offers.highPrice) * 100,
                title: data.offers.name || "Default Option",
                available:
                  data.offers.availability === "https://schema.org/InStock",
              });
            }

            if (simplifiedProduct.variants.length > 0) {
              this.productData = simplifiedProduct;
              this.extractVariantData();
              return true;
            }
          }
        } catch (e) {}
      }

      this.createFallbackProductData();
      return true;
    } catch (error) {
      this.createFallbackProductData();
      return true;
    }
  }

  createFallbackProductData() {
    const monthlyPrice = 7900;
    const quarterlyPrice = 23724;
    const monthlyCompare = 9000;
    const quarterlyCompare = 27000;

    this.productData = {
      id: 1000000,
      variants: [
        {
          id: 1000001,
          price: monthlyPrice,
          title: "30 Days Supply",
          available: true,
        },
        {
          id: 1000002,
          price: quarterlyPrice,
          title: "90 Days Supply",
          available: true,
        },
        {
          id: 1000003,
          price: monthlyPrice,
          compare_at_price: monthlyCompare,
          title: "30 Days Supply (One Time)",
          available: true,
        },
        {
          id: 1000004,
          price: quarterlyPrice,
          compare_at_price: quarterlyCompare,
          title: "90 Days Supply (One Time)",
          available: true,
        },
      ],
    };

    this.extractVariantData();
  }

  async preloadSealData() {
    try {
      const sealSubsTarget = document.querySelector(".sealsubs-target-element");
      if (sealSubsTarget && sealSubsTarget.getAttribute("data-product")) {
        return true;
      }

      const maxAttempts = 5;
      for (let i = 0; i < maxAttempts; i++) {
        await new Promise((resolve) => setTimeout(resolve, 100));
        this.extractSealData();

        if (this.sellingPlans.monthly.id || this.sellingPlans.quarterly.id || this.sellingPlans.biannually.id ) {
          return true;
        }

        const sealContainer = document.querySelector(".sealsubs-container");
        if (sealContainer) {
          return true;
        }
      }
      return false;
    } catch (error) {
      return false;
    }
  }

  eagerInit() {
    const initAttempts = 5;
    let attempt = 0;

    const initCheck = () => {
      attempt++;
      this.extractSealData();

      const hasMonthlyPlan = !!this.sellingPlans.monthly?.id;
      const hasQuarterlyPlan = !!this.sellingPlans.quarterly?.id;
      const hasBiannuallyPlan = !!this.sellingPlans.biannually?.id;
      
      console.log('eagerInit this.sellingPlans = ', this.sellingPlans);
      
      const anyPlanInfoFound =
        hasMonthlyPlan ||
        hasQuarterlyPlan ||
        hasBiannuallyPlan ||
        !!document.querySelector(".sealsubs-container");

      const hasVariantData = !!(
        this.variants.monthly.price !== null ||
        this.variants.quarterly.price !== null ||
        this.variants.biannually.price !== null ||
        this.variants.monthlyOnetime.price !== null ||
        this.variants.quarterlyOnetime.price !== null || 
        this.variants.biannuallyOnetime.price !== null
      );

      if (
        hasVariantData &&
        (anyPlanInfoFound ||
          attempt >= initAttempts ||
          Date.now() - this.failsafeInitTime > 1000)
      ) {
        if (this.initialized) return;
        this.forceExtractSellingPlans();
        this.init();
        this.initialized = true;
        window.kadesoInitializing = false;
        return;
      }

      if (attempt < initAttempts && Date.now() - this.failsafeInitTime < 1000) {
        const timeout = setTimeout(initCheck, 150);
        this.timeouts.push(timeout);
      } else {
        this.forceExtractSellingPlans();
        this.init();
        this.initialized = true;
        window.kadesoInitializing = false;
      }
    };

    const timeout = setTimeout(initCheck, 10);
    this.timeouts.push(timeout);
  }

  forceInitialize() {
     console.log('forceInitialize this.sellingPlans = ', this.sellingPlans);
    if (this.initialized) return;

    if (!this.productData) {
      this.createFallbackProductData();
    }

    this.forceExtractSellingPlans();
    this.init();
    this.initialized = true;
    window.kadesoInitializing = false;
  }

  forceExtractSellingPlans() {
    console.log('forceExtractSellingPlans this.sellingPlans = ', this.sellingPlans);
    if (
      this.sellingPlans.monthly.id &&
      this.sellingPlans.monthly.discount !== null &&
      this.sellingPlans.quarterly.id &&
      this.sellingPlans.quarterly.discount !== null && 
      this.sellingPlans.biannually.id &&
      this.sellingPlans.biannually.discount !== null
    ) {
      return;
    }

    const sealMonthlyRadio = document.querySelector('.sls-option[value="0"]');
    const sealQuarterlyRadio = document.querySelector('.sls-option[value="1"]');
    const sealBiannuallyRadio = document.querySelector('.sls-option[value="2"]');
    
    if (sealMonthlyRadio || sealQuarterlyRadio || sealBiannuallyRadio) {
      const monthlySelect = sealMonthlyRadio
        ?.closest(".sls-option-container")
        ?.querySelector("select.sls-select");
      const quarterlySelect = sealQuarterlyRadio
        ?.closest(".sls-option-container")
        ?.querySelector("select.sls-select");
      const biannuallySelect = sealBiannuallyRadio
        ?.closest(".sls-option-container")
        ?.querySelector("select.sls-select");
      
      if (!this.sellingPlans.monthly.id && monthlySelect?.options[0]?.value) {
        this.sellingPlans.monthly.id = monthlySelect.options[0].value;
      }

      if (!this.sellingPlans.quarterly.id && quarterlySelect?.options[0]?.value ) {
        this.sellingPlans.quarterly.id = quarterlySelect.options[0].value;
      }

      if (!this.sellingPlans.biannually.id && biannuallySelect?.options[0]?.value ) {
        this.sellingPlans.biannually.id = biannuallySelect.options[0].value;
      }
    }

    if (!this.sellingPlans.monthly.id) {
      const allInputs = document.querySelectorAll(
        'input[name="selling_plan"], select[name="selling_plan"] option'
      );
      const values = Array.from(allInputs)
        .map((el) => el.value)
        .filter(Boolean);

      if (values.length > 0) {
        console.log('values.length = ', values.length);
        this.sellingPlans.monthly.id = values[0];
        if (values.length > 2) {
          this.sellingPlans.biannually.id = values[2];
        } else if (values.length > 1) {
          this.sellingPlans.quarterly.id = values[1];
        } else {
          this.sellingPlans.quarterly.id = values[0];
        }
      } else {
        this.sellingPlans.monthly.id = "1234567890";
        this.sellingPlans.quarterly.id = "1234567891";
      }
    }
/*    willow
    if (!this.sellingPlans.monthly.discount) {
      this.sellingPlans.monthly.discount = 13.92;
    }

    if (!this.sellingPlans.quarterly.discount) {
      this.sellingPlans.quarterly.discount = 19.83;
    }*/
  }

  detectLanguage() {
    const htmlLang = document.documentElement.lang || "";
    const shopifyLocale =
      window.Shopify && window.Shopify.locale ? window.Shopify.locale : "";
    const localePath = window.location.pathname.match(/^\/([\w-]+)\//);

    const activeLanguageElement = document.querySelector(
      ".disclosure__link--active, .active[data-currency], .localization-selector option:checked"
    );
    const activeLanguage = activeLanguageElement
      ? (
          activeLanguageElement.getAttribute("lang") ||
          activeLanguageElement.getAttribute("data-value") ||
          activeLanguageElement.textContent ||
          ""
        ).toLowerCase()
      : "";

    const urlParams = new URLSearchParams(window.location.search);
    const localeParam = urlParams.get("locale") || "";

    if (
      htmlLang.toLowerCase().includes("nl") ||
      shopifyLocale.toLowerCase().includes("nl") ||
      (localePath && localePath[1].toLowerCase() === "nl") ||
      activeLanguage.includes("nl") ||
      localeParam.toLowerCase().includes("nl")
    ) {
      return "dutch";
    }

    return "english";
  }

  getVariantMetafields(variantId) {
    if (!variantId) return null;
    
    if (window.productMetafields && window.productMetafields[variantId]) {
      return window.productMetafields[variantId];
    }

    const metafieldsElement = document.getElementById(
      `variant-metafields-${variantId}`
    );
    if (metafieldsElement) {
      try {
        return JSON.parse(metafieldsElement.textContent);
      } catch (e) {
        return null;
      }
    }

    return null;
  }

  getBenefitText(variantType, benefitIndex) {

    const variant = this.variants[variantType];

    const lang = this.currentLanguage;

    if (variant && variant.metafields) {
      const metafieldKey = `benefits_${benefitIndex}_${lang}`;
      if (variant.metafields[metafieldKey]) {
        return variant.metafields[metafieldKey];
      }
    }

    return "";
  }

  getPriceperdayText(variantType) {
  
    const variant = this.variants[variantType];

    console.log('variantType = ', variantType);
    console.log('priceperday = ', variant.metafields['priceperday']);
    
    if (variant && variant.metafields) {
      if (variant.metafields['priceperday']) {
        return variant.metafields['priceperday'];
      }
    }
    return "";
  }
    
  async loadProductData() {
    console.log('loadProductData ---------------- ');
    const productDataEl = document.getElementById("kadeso-product-data");

    if (productDataEl && productDataEl.textContent) {
      try {
        const productJson = JSON.parse(productDataEl.textContent);
        if (
          productJson &&
          typeof productJson === "object" &&
          productJson.id &&
          Array.isArray(productJson.variants) &&
          productJson.variants.length > 0
        ) {
          this.productData = productJson;
          this.extractVariantData();
          return true;
        }
      } catch (error) {}
    }

    const productHandle = this.getProductHandle();
    if (!productHandle) {
      return false;
    }

    try {
      const fetchUrl = `/products/${productHandle}.js`;
      const response = await fetch(fetchUrl, {
        method: "GET",
        headers: { Accept: "application/json" },
        cache: "default",
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const fetchedProductData = await response.json();

      if (
        fetchedProductData &&
        typeof fetchedProductData === "object" &&
        fetchedProductData.id &&
        Array.isArray(fetchedProductData.variants) &&
        fetchedProductData.variants.length > 0
      ) {
        this.productData = fetchedProductData;
        this.extractVariantData();
        return true;
      } else {
        throw new Error("Invalid product data structure");
      }
    } catch (error) {
      return false;
    }
  }

  getProductHandle() {
    try {
      const pathParts = window.location.pathname.split("/products/");
      if (pathParts.length > 1) {
        return pathParts[1].split("/")[0].split("?")[0];
      }
    } catch (e) {}
    return null;
  }

  extractVariantData() {
    if (
      !this.productData ||
      !Array.isArray(this.productData.variants) ||
      this.productData.variants.length === 0
    ) {
      // No valid product data or variants found
      return;
    }

    console.log('this.productData = ', this.productData);
    
    // Extracting variants from product data

    this.productData.variants.forEach((variant) => {
      if (!variant || typeof variant !== "object") {
        return;
      }

      if (
        typeof variant.title !== "string" ||
        typeof variant.price === "undefined" ||
        variant.price === null
      ) {
        return;
      }

      const title = variant.title.toLowerCase();
      const price = variant.price;
      const compareAtPrice = variant.compare_at_price;
      const id = variant.id;
      const available = variant.available;
      const metafields = this.getVariantMetafields(id);
      
      // Debug log for each variant
      console.log('[KADESO DEBUG] Processing variant: ', variant);
      console.log(`[KADESO DEBUG] Processing variant: "${title}" (${id})`, {
        price,
        compareAtPrice,
        available,
        language: this.currentLanguage,
        is30Day:
          title.includes("30") ||
          title.includes("1-maand") ||
          title.includes("1 maand"),
        is90Day:
          title.includes("90") ||
          title.includes("3-maanden") ||
          title.includes("3 maanden"),
        is180Day:
          title.includes("180") ||
          title.includes("6-maanden") ||
          title.includes("6 maanden"),
        isSubscription:
          title.includes("abbonement") || title.includes("abonnement"),
        isOneTime:
          title.includes("one time") ||
          title.includes("one-time") ||
          title.includes("eenmalig") ||
          title.includes("normale aankoop") ||
          (title.includes("voorraad") &&
            !title.includes("abonnement") &&
            !title.includes("abbonement")),
      });

      // Process variant

      if (!id) {
        return;
      }

      // Check if this is a subscription variant
      if (
        (title.includes("30") ||
          title.includes("1-maand") ||
          title.includes("1 maand")) &&
        (title.includes("abbonement") || title.includes("abonnement"))
      ) {
        // Found 30-day subscription variant
        this.variants.monthly = {
          id: id,
          price: price,
          title: variant.title,
          available: available,
          metafields: metafields,
        };
      } else if (
        (title.includes("90") ||
          title.includes("3-maanden") ||
          title.includes("3 maanden")) &&
        (title.includes("abbonement") || title.includes("abonnement"))
      ) {
        // Found 90-day subscription variant
        this.variants.quarterly = {
          id: id,
          price: price,
          title: variant.title,
          available: available,
          metafields: metafields,
        };
      } else if (
        (title.includes("180") ||
          title.includes("6-maanden") ||
          title.includes("6 maanden")) &&
        (title.includes("abbonement") || title.includes("abonnement"))
      ) {
        // Found 180-day subscription variant
        this.variants.biannually = {
          id: id,
          price: price,
          title: variant.title,
          available: available,
          metafields: metafields,
        };
      } else if (
        (title.includes("30") ||
          title.includes("1-maand") ||
          title.includes("1 maand")) &&
        (title.includes("one time purchase") ||
          title.includes("one time") ||
          title.includes("one-time") ||
          title.includes("normale aankoop") ||
          title.includes("eenmalig") ||
          title.includes("eenmalige"))
      ) {
        // Found 30-day one-time variant
        this.variants.monthlyOnetime = {
          id: id,
          price: price,
          compareAtPrice: compareAtPrice,
          title: variant.title,
          available: available,
          metafields: metafields,
        };
      } else if (
        (title.includes("90") ||
          title.includes("3-maanden") ||
          title.includes("3 maanden")) &&
        (title.includes("one time purchase") ||
          title.includes("one time") ||
          title.includes("one-time") ||
          title.includes("normale aankoop") ||
          title.includes("eenmalig") ||
          title.includes("eenmalige"))
      ) {
        // Found 90-day one-time variant
        this.variants.quarterlyOnetime = {
          id: id,
          price: price,
          compareAtPrice: compareAtPrice,
          title: variant.title,
          available: available,
          metafields: metafields,
        };
      } else if (
        (title.includes("180") ||
          title.includes("6-maanden") ||
          title.includes("6 maanden")) &&
        (title.includes("one time purchase") ||
          title.includes("one time") ||
          title.includes("one-time") ||
          title.includes("normale aankoop") ||
          title.includes("eenmalig") ||
          title.includes("eenmalige"))
      ) {
        // Found 180-day one-time variant
        this.variants.biannuallyOnetime = {
          id: id,
          price: price,
          compareAtPrice: compareAtPrice,
          title: variant.title,
          available: available,
          metafields: metafields,
        };
      }
    });

    if (!this.variants.monthly.id || !this.variants.quarterly.id || !this.variants.biannually.id ) {
      // Missing variants, attempting to find alternatives

      // When in Dutch mode, make special efforts to find the 90-day variant
      if (this.currentLanguage === "dutch") {
        // First try to find a variant that contains the Dutch name
        const dutchQuarterlyVariant = this.productData.variants.find(
          (v) =>
            v.title.toLowerCase().includes("3-maanden") ||
            v.title.toLowerCase().includes("90") ||
            v.title.toLowerCase().includes("3 maanden")
        );

        if (dutchQuarterlyVariant && !this.variants.quarterly.id) {
          // Found Dutch quarterly variant by title
          this.variants.quarterly = {
            id: dutchQuarterlyVariant.id,
            price: dutchQuarterlyVariant.price,
            title: dutchQuarterlyVariant.title,
            available: dutchQuarterlyVariant.available,
            metafields: this.getVariantMetafields(dutchQuarterlyVariant.id),
          };
        }
      }

      // If still missing variants, use price sorting as fallback
      if (!this.variants.monthly.id || !this.variants.quarterly.id) {
        const sortedVariants = [...this.productData.variants].sort(
          (a, b) => a.price - b.price
        );

        // Sorted variants by price

        if (sortedVariants.length > 0 && !this.variants.monthly.id) {
          const monthlyVariant = sortedVariants[0];
          // Using lowest price variant as monthly
          this.variants.monthly = {
            id: monthlyVariant.id,
            price: monthlyVariant.price,
            title: monthlyVariant.title,
            available: monthlyVariant.available,
            metafields: this.getVariantMetafields(monthlyVariant.id),
          };
        }

        // For quarterly, let's explicitly look for a higher-priced option
        // In Dutch mode, we want to make sure we're finding the correct 90-day supply
        if (sortedVariants.length > 1 && !this.variants.quarterly.id) {
          // Try to find a variant with significantly higher price (3x) for quarterly
          const higherPricedVariants = sortedVariants.filter(
            (v) => v.price > this.variants.monthly.price * 2.5
          );

          if (higherPricedVariants.length > 0) {
            const quarterlyVariant = higherPricedVariants[0];
            // Found higher-priced variant for quarterly
            this.variants.quarterly = {
              id: quarterlyVariant.id,
              price: quarterlyVariant.price,
              title: quarterlyVariant.title,
              available: quarterlyVariant.available,
              metafields: this.getVariantMetafields(quarterlyVariant.id),
            };
          } else {
            // Default to second variant if no higher-priced option found
            const quarterlyVariant = sortedVariants[1];
            // Using second cheapest variant as quarterly
            this.variants.quarterly = {
              id: quarterlyVariant.id,
              price: quarterlyVariant.price,
              title: quarterlyVariant.title,
              available: quarterlyVariant.available,
              metafields: this.getVariantMetafields(quarterlyVariant.id),
            };
          }
        } else if (sortedVariants.length > 0 && !this.variants.quarterly.id) {
          const singleVariant = sortedVariants[0];
          // Only one variant found, using for both monthly and quarterly
          this.variants.quarterly = {
            id: singleVariant.id,
            price: singleVariant.price,
            title: singleVariant.title,
            available: singleVariant.available,
            metafields: this.getVariantMetafields(singleVariant.id),
          };
        }
      }

      // Final variant selection after fallback
    }

    // No fallbacks - we need to use the actual variants
    // Log a warning if we're missing variants
    if ( !this.variants.monthlyOnetime.id || !this.variants.quarterlyOnetime.id || !this.variants.biannuallyOnetime.id  ) {
      console.log("[KADESO WARNING] Missing one-time purchase variants:", {
        monthlyOnetimeFound: !!this.variants.monthlyOnetime.id,
        quarterlyOnetimeFound: !!this.variants.quarterlyOnetime.id,
        biannuallyOnetimeFound: !!this.variants.biannuallyOnetime.id,
        language: this.currentLanguage,
      });
    }

    // Debug log to help diagnose variant detection issues
    console.log(
      "[KADESO DEBUG] All available variants:",
      this.productData.variants.map((v) => ({
        id: v.id,
        title: v.title,
        price: v.price,
        compareAtPrice: v.compare_at_price,
      }))
    );

    console.log("[KADESO DEBUG] Detected variants:", {
      monthly: {
        id: this.variants.monthly.id,
        price: this.variants.monthly.price,
        title: this.variants.monthly.title,
      },
      quarterly: {
        id: this.variants.quarterly.id,
        price: this.variants.quarterly.price,
        title: this.variants.quarterly.title,
      },
      biannually: {
        id: this.variants.biannually.id,
        price: this.variants.biannually.price,
        title: this.variants.biannually.title,
      },
      monthlyOnetime: {
        id: this.variants.monthlyOnetime.id,
        price: this.variants.monthlyOnetime.price,
        compareAtPrice: this.variants.monthlyOnetime.compareAtPrice,
        title: this.variants.monthlyOnetime.title,
      },
      quarterlyOnetime: {
        id: this.variants.quarterlyOnetime.id,
        price: this.variants.quarterlyOnetime.price,
        compareAtPrice: this.variants.quarterlyOnetime.compareAtPrice,
        title: this.variants.quarterlyOnetime.title,
      },
      biannuallyOnetime: {
        id: this.variants.biannuallyOnetime.id,
        price: this.variants.biannuallyOnetime.price,
        compareAtPrice: this.variants.biannuallyOnetime.compareAtPrice,
        title: this.variants.biannuallyOnetime.title,
      },
      language: this.currentLanguage,
    });

    this.getCurrentVariantPrices();
  }

  extractSealData() {
    try {
      console.log('extractSealData this.sellingPlans = ', this.sellingPlans);
      this.sealContainer = document.querySelector(".sealsubs-container");

      const sealSubsTarget = document.querySelector(".sealsubs-target-element");
      if (sealSubsTarget && sealSubsTarget.getAttribute("data-product")) {
        const productData = JSON.parse(
          sealSubsTarget.getAttribute("data-product")
        );
        if (productData && productData.selling_plan_groups) {
          const monthlyGroup = productData.selling_plan_groups.find(
            (g) =>
              g.name.includes("30") ||
              g.selling_plans.some((p) =>
                p.options.some((o) => o.value === "30 days")
              )
          );

          if (
            monthlyGroup &&
            monthlyGroup.selling_plans &&
            monthlyGroup.selling_plans.length > 0
          ) {
            const monthlyPlan = monthlyGroup.selling_plans[0];
            this.sellingPlans.monthly.id = monthlyPlan.id;
            
            if (
              monthlyPlan.price_adjustments &&
              monthlyPlan.price_adjustments.length > 0
            ) {
              
              this.sellingPlans.monthly.discount = parseFloat(monthlyPlan.price_adjustments[0].value);
              this.sellingPlans.monthly.discount_type = monthlyPlan.price_adjustments[0].value_type;              
            }
          }

          const quarterlyGroup = productData.selling_plan_groups.find(
            (g) =>
              g.name.includes("90") ||
              g.selling_plans.some((p) =>
                p.options.some((o) => o.value === "3 months")
              )
          );

          if (
            quarterlyGroup &&
            quarterlyGroup.selling_plans &&
            quarterlyGroup.selling_plans.length > 0
          ) {
            const quarterlyPlan = quarterlyGroup.selling_plans[0];
              
            console.log('quarterlyPlan = ', quarterlyPlan);
            
            this.sellingPlans.quarterly.id = quarterlyPlan.id;
            if (
              quarterlyPlan.price_adjustments &&
              quarterlyPlan.price_adjustments.length > 0
            ) {
              this.sellingPlans.quarterly.discount = parseFloat(quarterlyPlan.price_adjustments[0].value);
              this.sellingPlans.quarterly.discount_type = quarterlyPlan.price_adjustments[0].value_type;
            }
          }

          const biannuallyGroup = productData.selling_plan_groups.find(
            (g) =>
              g.name.includes("180") ||
              g.selling_plans.some((p) =>
                p.options.some((o) => o.value === "6 months")
              )
          );

          if (
            biannuallyGroup &&
            biannuallyGroup.selling_plans &&
            biannuallyGroup.selling_plans.length > 0
          ) {
            const biannuallyPlan = biannuallyGroup.selling_plans[0];
            this.sellingPlans.biannually.id = biannuallyPlan.id;
            if (
              biannuallyPlan.price_adjustments &&
              biannuallyPlan.price_adjustments.length > 0
            ) {
              this.sellingPlans.biannually.discount = parseFloat(
                biannuallyPlan.price_adjustments[0].value
              );
            }
          }


          if (this.sellingPlans.monthly.id || this.sellingPlans.quarterly.id || this.sellingPlans.biannually.id) {
            return;
          }
        }
      }

      this.sellingPlanInput =
        document.querySelector('input[name="selling_plan"]') ||
        document.querySelector("input[data-sls-selling_plan]");

      const monthlyRadio = document.querySelector('.sls-option[value="0"]');
      const quarterlyRadio = document.querySelector('.sls-option[value="1"]');
      const biannuallyRadio = document.querySelector('.sls-option[value="1"]');
      
      const monthlyDiscountEl = monthlyRadio
        ?.closest(".sls-option-container")
        ?.querySelector(".sls-savings-badge");
      const quarterlyDiscountEl = quarterlyRadio
        ?.closest(".sls-option-container")
        ?.querySelector(".sls-savings-badge");
      const biannuallyDiscountEl = biannuallyRadio
        ?.closest(".sls-option-container")
        ?.querySelector(".sls-savings-badge");
      
      let monthlyDiscount = null;
      let quarterlyDiscount = null;
      let biannuallyDiscount = null;

      if (monthlyDiscountEl) {
        const discountMatch =
          monthlyDiscountEl.textContent.match(/save\s+([\d.]+)\s*%/i);
        if (discountMatch && discountMatch[1]) {
          monthlyDiscount = parseFloat(discountMatch[1]);
          if (isNaN(monthlyDiscount)) monthlyDiscount = null;
        }
      }

      if (quarterlyDiscountEl) {
        const discountMatch =
          quarterlyDiscountEl.textContent.match(/save\s+([\d.]+)\s*%/i);
        if (discountMatch && discountMatch[1]) {
          quarterlyDiscount = parseFloat(discountMatch[1]);
          if (isNaN(quarterlyDiscount)) quarterlyDiscount = null;
        }
      }

      if (biannuallyDiscountEl) {
        const discountMatch =
          biannuallyDiscountEl.textContent.match(/save\s+([\d.]+)\s*%/i);
        if (discountMatch && discountMatch[1]) {
          biannuallyDiscount = parseFloat(discountMatch[1]);
          if (isNaN(biannuallyDiscount)) biannuallyDiscount = null;
        }
      }

      const monthlySelect = monthlyRadio
        ?.closest(".sls-option-container")
        ?.querySelector("select.sls-select");
      const quarterlySelect = quarterlyRadio
        ?.closest(".sls-option-container")
        ?.querySelector("select.sls-select");
      const biannuallySelect = biannuallyRadio
        ?.closest(".sls-option-container")
        ?.querySelector("select.sls-select");

      if (monthlySelect?.options[0]?.value) {
        this.sellingPlans.monthly.id = monthlySelect.options[0].value;
      }

      console.log('monthlyDiscount = ', monthlyDiscount);
      
      if (monthlyDiscount !== null) {
        this.sellingPlans.monthly.discount = monthlyDiscount;
      }

      if (quarterlySelect?.options[0]?.value) {
        this.sellingPlans.quarterly.id = quarterlySelect.options[0].value;
      }

      if (quarterlyDiscount !== null) {
        this.sellingPlans.quarterly.discount = quarterlyDiscount;
      }

      if (biannuallySelect?.options[0]?.value) {
        this.sellingPlans.biannually.id = biannuallySelect.options[0].value;
      }

      if (biannuallyDiscount !== null) {
        this.sellingPlans.biannually.discount = biannuallyDiscount;
      }
      
      if (!this.sellingPlans.monthly.id || !this.sellingPlans.quarterly.id || !this.sellingPlans.biannually.id) {
        const sellingPlanSelects = document.querySelectorAll(
          'select[name="selling_plan"], [data-sls-selling_plan]'
        );
        sellingPlanSelects.forEach((select) => {
          const options = Array.from(select.options).filter((o) => o.value);
          if (options.length > 0 && !this.sellingPlans.monthly.id) {
            this.sellingPlans.monthly.id = options[0].value;
          }
          if (options.length > 1 && !this.sellingPlans.quarterly.id) {
            this.sellingPlans.quarterly.id = options[1].value;
          }
          if (options.length > 2 && !this.sellingPlans.biannually.id) {
            this.sellingPlans.biannually.id = options[2].value;
          }
        });
      }
    } catch (error) {}
  }

  getCurrentVariantPrices() {
    this.prices = {
      monthly:
        this.variants.monthly.price !== null
          ? this.formatPrice(this.variants.monthly.price)
          : null,
      quarterly:
        this.variants.quarterly.price !== null
          ? this.formatPrice(this.variants.quarterly.price)
          : null,
      biannually:
        this.variants.biannually.price !== null
          ? this.formatPrice(this.variants.biannually.price)
          : null,
      monthlyOnetime:
        this.variants.monthlyOnetime.price !== null
          ? this.formatPrice(this.variants.monthlyOnetime.price)
          : null,
      quarterlyOnetime:
        this.variants.quarterlyOnetime.price !== null
          ? this.formatPrice(this.variants.quarterlyOnetime.price)
          : null,
      biannuallyOnetime:
        this.variants.biannuallyOnetime.price !== null
          ? this.formatPrice(this.variants.biannuallyOnetime.price)
          : null,
      monthlyOnetimeCompare:
        this.variants.monthlyOnetime.compareAtPrice !== null
          ? this.formatPrice(this.variants.monthlyOnetime.compareAtPrice)
          : null,
      quarterlyOnetimeCompare:
        this.variants.quarterlyOnetime.compareAtPrice !== null
          ? this.formatPrice(this.variants.quarterlyOnetime.compareAtPrice)
          : null,
      biannuallyOnetimeCompare:
        this.variants.biannuallyOnetime.compareAtPrice !== null
          ? this.formatPrice(this.variants.biannuallyOnetime.compareAtPrice)
          : null,
    };
  }

  init() {
    if (!this.placeholder) {
      return;
    }

    this.findElements();

    this.getCurrentVariantPrices();
    const priceData = this.getFormattedPriceData();

    if (!priceData) {
      if (this.placeholder) {
        this.placeholder.innerHTML =
          '<p class="kadeso-error">Error loading price data.</p>';
      }
      return;
    }

    this.determineInitialMode(priceData);
    this.createCustomUI(priceData);
    this.connectEvents(priceData);
    this.placeholder.style.opacity = "1";
    const loading = this.placeholder.querySelector(".kadeso-loading");
    if (loading) loading.remove();

    this.timeouts.forEach((timeout) => {
      if (timeout) clearTimeout(timeout);
    });
    this.timeouts = [];

  }

  determineInitialMode(priceData) {

    console.log('determineInitialMode priceData = ', priceData);
    
    const monthlySubAvailable = !!(
      priceData.monthlyVariantId &&
      priceData.monthlyPriceRaw !== null &&
      this.sellingPlans.monthly.id
    );

    const quarterlySubAvailable = !!(
      priceData.quarterlyVariantId &&
      priceData.quarterlyPriceRaw !== null &&
      this.sellingPlans.quarterly.id
    );

     const biannuallySubAvailable = !!(
      priceData.biannuallyVariantId &&
      priceData.biannuallyPriceRaw !== null &&
      this.sellingPlans.biannually.id
    );

    const monthlyOneTimeAvailable = !!(
      priceData.monthlyOnetimeVariantId &&
      priceData.monthlyOnetimePriceRaw !== null
    );

    const quarterlyOneTimeAvailable = !!(
      priceData.quarterlyOnetimeVariantId &&
      priceData.quarterlyOnetimePriceRaw !== null
    );

    const biannuallyOneTimeAvailable = !!(
      priceData.biannuallyOnetimeVariantId &&
      priceData.biannuallyOnetimePriceRaw !== null
    );

    const anySubAvailable = monthlySubAvailable || quarterlySubAvailable || biannuallySubAvailable;
    const anyOneTimeAvailable =
      monthlyOneTimeAvailable || quarterlyOneTimeAvailable || biannuallyOneTimeAvailable;

    if (anyOneTimeAvailable) {
      this.mode = "onetime";
    } else if (anySubAvailable) {
      this.mode = "subscription";
    } else {
      this.mode = "subscription";
    }
    /* by-willow
    if (anySubAvailable) {
      this.mode = "subscription";
    } else if (anyOneTimeAvailable) {
      this.mode = "onetime";
    } else {
      this.mode = "subscription";
    }*/
  }

  calculateOnetimeDiscount(price, compareAtPrice) {
    if (!price || !compareAtPrice || compareAtPrice <= price) return null;
    return ((compareAtPrice - price) / compareAtPrice) * 100;
  }

  getFormattedPriceData() {
    console.log('this.variants = ', this.variants);
    const monthlyPrice = this.parsePrice(this.variants.monthly.price);
    const quarterlyPrice = this.parsePrice(this.variants.quarterly.price);
    const biannuallyPrice = this.parsePrice(this.variants.biannually.price);
    
    const monthlyOnetimePrice = this.parsePrice(
      this.variants.monthlyOnetime.price
    );
    const quarterlyOnetimePrice = this.parsePrice(
      this.variants.quarterlyOnetime.price
    );
    const biannuallyOnetimePrice = this.parsePrice(
      this.variants.biannuallyOnetime.price
    );

    console.log('biannuallyOnetimePrice 1 = ', biannuallyOnetimePrice);
    
    const monthlyOnetimeComparePrice = this.parsePrice(
      this.variants.monthlyOnetime.compareAtPrice
    );
    const quarterlyOnetimeComparePrice = this.parsePrice(
      this.variants.quarterlyOnetime.compareAtPrice
    );
    const biannuallyOnetimeComparePrice = this.parsePrice(
      this.variants.biannuallyOnetime.compareAtPrice
    );

    console.log('this.sellingPlans === ', this.sellingPlans);

    
    var monthly_discount_type = this.sellingPlans.monthly?.discount_type;
    var monthly_discount_percent = 0;
    var monthlyDiscount = this.sellingPlans.monthly?.discount;
    var monthly_discounted_price = 0;  
    
    if (monthly_discount_type == 'percentage') {
      monthly_discount_percent = (monthlyDiscount ?? 0) / 100;
      monthly_discounted_price = !isNaN(monthlyPrice) && monthly_discount_percent > 0 ? monthlyPrice * (1 - monthly_discount_percent) : monthlyPrice;
    } else if (monthly_discount_type == 'fixed_amount') {
      monthlyDiscount = monthlyDiscount/100;
      monthly_discount_percent =  monthlyDiscount/monthlyPrice ;
      monthly_discounted_price =  monthlyPrice - monthlyDiscount;
    }

    monthly_discount_percent = monthly_discount_percent * 100;
    
    console.log('monthly_discount_percent = ', monthly_discount_percent);
    
    var quarterly_discount_type = this.sellingPlans.quarterly?.discount_type;
    var quarterly_discount_percent = 0;
    var quarterlyDiscount = this.sellingPlans.quarterly?.discount;
    var quarterly_discounted_price = 0;
    
    if (quarterly_discount_type == 'percentage') {
      quarterly_discount_percent =  (quarterlyDiscount ?? 0) / 100;
      quarterly_discounted_price = !isNaN(quarterlyPrice) && quarterly_discount_percent > 0 ? quarterlyPrice * (1 - quarterly_discount_percent) : quarterlyPrice;
    } else if (monthly_discount_type == 'fixed_amount') {
      quarterlyDiscount = quarterlyDiscount/100;
      quarterly_discount_percent =  quarterlyDiscount/quarterlyPrice ;
      quarterly_discounted_price =  quarterlyPrice - quarterlyDiscount;
    }
    quarterly_discount_percent = quarterly_discount_percent * 100;
    
    var biannually_discount_type = this.sellingPlans.biannually?.discount_type;
    var biannually_discount_percent = 0;
    var biannuallyDiscount = this.sellingPlans.biannually?.discount;
    var biannually_discounted_price = 0;  
    
    if (biannually_discount_type == 'percentage') {
      biannually_discount_percent = (biannuallyDiscount ?? 0) / 100;
      biannually_discounted_price = !isNaN(biannuallyPrice) && biannually_discount_percent > 0 ? biannuallyPrice * (1 - biannually_discount_percent) : biannuallyPrice;
    } else if (monthly_discount_type == 'fixed_amount') {
      biannuallyDiscount = biannuallyDiscount/100;
      biannually_discount_percent =  biannuallyDiscount/biannuallyPrice ;
      biannually_discounted_price =  biannuallyPrice - biannuallyDiscount;
    }
    biannually_discount_percent = biannually_discount_percent * 100;
        
    const monthlyOnetimeDiscount = this.calculateOnetimeDiscount(
      monthlyOnetimePrice,
      monthlyOnetimeComparePrice
    );
    const quarterlyOnetimeDiscount = this.calculateOnetimeDiscount(
      quarterlyOnetimePrice,
      quarterlyOnetimeComparePrice
    );
    const biannuallyOnetimeDiscount = this.calculateOnetimeDiscount(
      biannuallyOnetimePrice,
      biannuallyOnetimeComparePrice
    );
    
    // Calculate discounted prices
    
    const formatNullablePrice = (priceVal) =>
      !isNaN(priceVal) ? this.formatPrice(priceVal) : "Unavailable";
    
    const formatNullableDiscount = (discountVal) => {
      if (discountVal === null) return null;
      // Round to nearest integer for cleaner display
      const roundedDiscount = Math.round(discountVal);
      return this.currentLanguage === "dutch"
        ? `${roundedDiscount.toFixed(2).replace(".", ",")} %`
        : `${roundedDiscount.toFixed(2)} %`;
    };
    
    const priceData = {
      monthlyVariantId: this.variants.monthly.id,
      quarterlyVariantId: this.variants.quarterly.id,
      biannuallyVariantId: this.variants.biannually.id,
      monthlyOnetimeVariantId: this.variants.monthlyOnetime.id,
      quarterlyOnetimeVariantId: this.variants.quarterlyOnetime.id,
      biannuallyOnetimeVariantId: this.variants.biannuallyOnetime.id,
      
      monthlyPrice: formatNullablePrice(monthlyPrice),
      quarterlyPrice: formatNullablePrice(quarterlyPrice),
      biannuallyPrice: formatNullablePrice(biannuallyPrice),
      monthlyOnetimePrice: formatNullablePrice(monthlyOnetimePrice),
      quarterlyOnetimePrice: formatNullablePrice(quarterlyOnetimePrice),
      biannuallyOnetimePrice: formatNullablePrice(biannuallyOnetimePrice),
      
      monthlyOnetimeComparePrice: formatNullablePrice(
        monthlyOnetimeComparePrice
      ),
      quarterlyOnetimeComparePrice: formatNullablePrice(
        quarterlyOnetimeComparePrice
      ),
      biannuallyOnetimeComparePrice: formatNullablePrice(
        biannuallyOnetimeComparePrice
      ),

      monthly_discounted_price: formatNullablePrice(monthly_discounted_price),
      quarterly_discounted_price: formatNullablePrice(quarterly_discounted_price),
      biannually_discounted_price: formatNullablePrice(quarterly_discounted_price),

      monthlyPriceRaw: !isNaN(monthlyPrice) ? monthlyPrice : null,
      quarterlyPriceRaw: !isNaN(quarterlyPrice) ? quarterlyPrice : null,
      biannuallyPriceRaw: !isNaN(biannuallyPrice) ? biannuallyPrice : null,
      monthly_discounted_priceRaw: !isNaN(monthly_discounted_price)
        ? monthly_discounted_price
        : null,
      quarterly_discounted_priceRaw: !isNaN(quarterly_discounted_price)
        ? quarterly_discounted_price
        : null,
      biannually_discounted_priceRaw: !isNaN(biannually_discounted_price)
        ? biannually_discounted_price
        : null,
      monthlyOnetimePriceRaw: !isNaN(monthlyOnetimePrice)
        ? monthlyOnetimePrice
        : null,
      quarterlyOnetimePriceRaw: !isNaN(quarterlyOnetimePrice)
        ? quarterlyOnetimePrice
        : null,
      biannuallyOnetimePriceRaw: !isNaN(biannuallyOnetimePrice)
        ? biannuallyOnetimePrice
        : null,

      discountMonthlyText: formatNullableDiscount(monthly_discount_percent),
      discountQuarterlyText: formatNullableDiscount(quarterly_discount_percent),
      discountbiannuallyText: formatNullableDiscount(biannually_discount_percent),
      discountMonthlyOnetimeText: formatNullableDiscount(
        monthlyOnetimeDiscount
      ),
      discountQuarterlyOnetimeText: formatNullableDiscount(
        quarterlyOnetimeDiscount
      ),
      discountbiannuallyOnetimeText: formatNullableDiscount(
        biannuallyOnetimeDiscount
      ),

      hasMonthlyOnetimeDiscount: monthlyOnetimeDiscount !== null,
      hasQuarterlyOnetimeDiscount: quarterlyOnetimeDiscount !== null,
      hasbiannuallyOnetimeDiscount: biannuallyOnetimeDiscount !== null,
    };

    // Debug log to help diagnose price formatting issues
    console.log("[KADESO DEBUG] Formatted price data:", priceData);

    // Log a warning if prices are incorrect
    if (
      this.currentLanguage === "dutch" &&
      (priceData.monthlyOnetimePrice === "Unavailable" || priceData.quarterlyOnetimePrice === "Unavailable" || priceData.biannuallyOnetimePrice === "Unavailable" )
    ) {
      console.log(
        "[KADESO WARNING] Missing prices for one-time purchase variants in Dutch mode"
      );
    }

    return priceData;
  }

  renderBenefits(variantType) {
    const benefits = [];

    for (let i = 1; i <= 3; i++) {
      const benefitText = this.getBenefitText(variantType, i);
      if (benefitText) {
        const classes =
          i === 1 ? "orange-dot" : i === 2 ? "cycle-icon" : "clock-icon";
        benefits.push(`<div class="benefit ${classes}">${benefitText}</div>`);
      }
    }

    return benefits.length > 0
      ? `<div class="benefits-container">${benefits.join("")}</div>`
      : "";
  }

  createCustomUI(priceData) {
    if (!this.placeholder || !priceData) return;

    const customContainer = document.createElement("div");
    customContainer.className = "kadeso-subscription-container";

    let monthlySelected = false;
    let selectedOption = '';

    console.log('priceData = ', priceData);
    
    const monthlySubAvailable = !!(
      priceData.monthlyVariantId &&
      priceData.monthlyPriceRaw !== null &&
      this.sellingPlans.monthly.id
    );

    const quarterlySubAvailable = !!(
      priceData.quarterlyVariantId &&
      priceData.quarterlyPriceRaw !== null &&
      this.sellingPlans.quarterly.id
    );

    const biannuallySubAvailable = !!(
      priceData.biannuallyVariantId &&
      priceData.biannuallyPriceRaw !== null &&
      this.sellingPlans.biannually.id
    );

    const monthlyOneTimeAvailable = !!(
      priceData.monthlyOnetimeVariantId &&
      priceData.monthlyOnetimePriceRaw !== null
    );

    const quarterlyOneTimeAvailable = !!(
      priceData.quarterlyOnetimeVariantId &&
      priceData.quarterlyOnetimePriceRaw !== null
    );
    
    const biannuallyOneTimeAvailable = !!(
      priceData.biannuallyOnetimeVariantId &&
      priceData.biannuallyOnetimePriceRaw !== null
    );

    // Determine if any options are available for UI display
    console.log("[KADESO DEBUG] UI Options Availability:", {
      monthlySubAvailable,
      quarterlySubAvailable,
      biannuallySubAvailable,
      monthlyOneTimeAvailable,
      quarterlyOneTimeAvailable,
      biannuallyOneTimeAvailable,
      mode: this.mode,
      language: this.currentLanguage,
      monthlyOnetimeVariantId: priceData.monthlyOnetimeVariantId,
      quarterlyOnetimeVariantId: priceData.quarterlyOnetimeVariantId,
      biannuallyOnetimeVariantId: priceData.biannuallyOnetimeVariantId,
    });

    // Log a warning if no options are available for the current mode
    if (
      this.mode === "onetime" &&
      !monthlyOneTimeAvailable &&
      !quarterlyOneTimeAvailable &&
      !biannuallyOneTimeAvailable
    ) {
      console.log(
        "[KADESO WARNING] No one-time purchase options available in one-time purchase mode"
      );
    } else if (
      this.mode === "subscription" &&
      !monthlySubAvailable &&
      !quarterlySubAvailable &&
      !biannuallySubAvailable
    ) {
      console.log(
        "[KADESO WARNING] No subscription options available in subscription mode"
      );
    }

    if (this.mode === "subscription") {
      if (quarterlySubAvailable) {
        //monthlySelected = false;
        selectedOption = 'quarterly';
      }
      else if (monthlySubAvailable) {
        //monthlySelected = true;
        selectedOption = 'monthly';
      } else if (biannuallySubAvailable) {
        //monthlySelected = false;
        selectedOption = 'biannually';
      } 
    } else {
      if (quarterlyOneTimeAvailable) {
        //monthlySelected = false;
        selectedOption = 'quarterly';
      }
      else if (monthlyOneTimeAvailable) {
        //monthlySelected = true;
        selectedOption = 'monthly';
      } else if (biannuallyOneTimeAvailable) {
        //monthlySelected = false;
        selectedOption = 'biannually';
      }
    }

    const textConstants = this.getUITextConstants();
    let contentHTML = "";
    let currentModeHasOptions = false;

    if (this.mode === "subscription") {
      contentHTML = `<h2 class="subscription-header">${textConstants.subscribeAndSaveText}</h2>`;

      if (monthlySubAvailable) {
        currentModeHasOptions = true;
        contentHTML += this.buildMonthlySubscriptionHTML(
          priceData,
          //monthlySelected,
          selectedOption,
          textConstants.mostPopularText,
          textConstants.saveText
        );
      }

      if (quarterlySubAvailable) {
        currentModeHasOptions = true;
        contentHTML += this.buildQuarterlySubscriptionHTML(
          priceData,
          //monthlySelected,
          selectedOption,
          quarterlySubAvailable,
          textConstants.bestValueText,
          textConstants.saveText
        );
      }

      if (biannuallySubAvailable) {
        currentModeHasOptions = true;
        contentHTML += this.buildbiannuallySubscriptionHTML(
          priceData,
          //monthlySelected,
          selectedOption,
          biannuallySubAvailable,
          textConstants.bestValueText,
          textConstants.saveText
        );
      }

      // Only show one-time purchase option if at least one variant is available
      if (monthlyOneTimeAvailable || quarterlyOneTimeAvailable || biannuallyOneTimeAvailable) {
         var mostPopularText = '';
        if (quarterlyOneTimeAvailable) {
          mostPopularText = textConstants.mostPopularText;
        } 
        contentHTML += this.buildOneTimeOptionHTML(
            textConstants.oneTimePurchaseOptionText,
            textConstants.startingAtText,
            priceData.monthlyOnetimePrice,
            priceData.quarterlyOnetimePrice,
            priceData.biannuallyOnetimePrice
          );
      } else {
        console.log(
          "[KADESO WARNING] No one-time purchase variants available, hiding option"
        );
      }

      if (currentModeHasOptions) {
        var activePrice;
        if (selectedOption == 'monthly') {
          activePrice = priceData.monthly_discounted_price;
        } else if (selectedOption == 'quarterly') {
          activePrice = priceData.quarterly_discounted_price;
        } else if (selectedOption == 'biannually') {
          activePrice = priceData.biannually_discounted_price;
        }
        //const activePrice = monthlySelected
        //  ? priceData.monthly_discounted_price
        //  : priceData.quarterly_discounted_price;
        
        contentHTML += `
          <button class="custom-subscribe-button ngoc2" ${
            activePrice === "Unavailable" ? "disabled" : ""
          }>
            ${textConstants.subscribeText} ${activePrice}
          </button>
          <p class="delivery-note">${textConstants.freeShippingText}</p>`;
      }
    } else {

      var mostPopularText = '';
      if (quarterlyOneTimeAvailable) {
        mostPopularText = textConstants.mostPopularText;
      } 
      
      contentHTML = `<h2 class="subscription-header">${textConstants.oneTimePurchaseText}</h2>`;

      if (monthlyOneTimeAvailable) {
        currentModeHasOptions = true;
        const hasMonthlyCompare = !!(
          priceData.monthlyOnetimeComparePrice &&
          priceData.monthlyOnetimeComparePrice !== "Unavailable" &&
          priceData.monthlyOnetimeComparePrice !== priceData.monthlyOnetimePrice
        );
        
        contentHTML += `
          <div class="subscription-option monthly-option ${
            selectedOption === 'monthly' ? "selected" : ""
          }">
            <div class="option-row">
              <input type="radio" name="subscription-option" id="monthly-onetime" class="subscription-radio"
                    data-plan="monthly-onetime"
                    data-variant-id="${priceData.monthlyOnetimeVariantId}"
                    data-product-variant="monthly-onetime"
                    data-product-variant-price="${
                      priceData.monthlyOnetimePriceRaw
                    }"
                    ${selectedOption === 'monthly' ? "checked" : ""}>
              <label for="monthly-onetime">${
                textConstants.oneMonthSupplyText
              }</label>

              <div class="price-per-day txt1">${this.getPriceperdayText("monthlyOnetime")} ${this.perDayText}</div>
            </div>
            <div class="price-discount-container">
              <div class="pricing">
                ${
                  hasMonthlyCompare
                    ? `<span class="original-price">${priceData.monthlyOnetimeComparePrice}</span>`
                    : ""
                }
                <span class="current-price">${
                  priceData.monthlyOnetimePrice
                }</span>
              </div>
              
              ${
                priceData.discountMonthlyOnetimeText && hasMonthlyCompare
                  ? `<div class="discount-badge">${textConstants.saveText} ${priceData.discountMonthlyOnetimeText}</div>`
                  : ""
              }
            </div>
            ${this.renderBenefits("monthlyOnetime")}
          </div>`;
      }

      if (quarterlyOneTimeAvailable) {
        currentModeHasOptions = true;
        const hasQuarterlyCompare = !!(
          priceData.quarterlyOnetimeComparePrice &&
          priceData.quarterlyOnetimeComparePrice !== "Unavailable" &&
          priceData.quarterlyOnetimeComparePrice !==
            priceData.quarterlyOnetimePrice
        );

        contentHTML += `
          <div class="subscription-option quarterly-option ${
            selectedOption === 'quarterly' ? "selected" : ""
          }">
          
            <div class="option-tag">${mostPopularText}</div>
            <div class="option-row">
              <input type="radio" name="subscription-option" id="quarterly-onetime" class="subscription-radio"
                    data-plan="quarterly-onetime"
                    data-variant-id="${priceData.quarterlyOnetimeVariantId}"
                    data-product-variant="quarterly-onetime"
                    data-product-variant-price="${
                      priceData.quarterlyOnetimePriceRaw
                    }"
                    ${ selectedOption === 'quarterly' ? "checked" : ""}>
              <label for="quarterly-onetime">${
                textConstants.threeMonthsSupplyText
              }</label>
              
              <div class="price-per-day txt2">${ this.getPriceperdayText("quarterlyOnetime")} ${this.perDayText}</div>
            </div>
            <div class="price-discount-container">
              <div class="pricing">
                ${
                  hasQuarterlyCompare
                    ? `<span class="original-price">${priceData.quarterlyOnetimeComparePrice}</span>`
                    : ""
                }
                <span class="current-price">${
                  priceData.quarterlyOnetimePrice
                }</span>
              </div>
              ${
                priceData.discountQuarterlyOnetimeText && hasQuarterlyCompare
                  ? `<div class="discount-badge">${textConstants.saveText} ${priceData.discountQuarterlyOnetimeText}</div>`
                  : ""
              }
            </div>
            ${this.renderBenefits("quarterlyOnetime")}
          </div>`;
      }

      if (biannuallyOneTimeAvailable) {
        currentModeHasOptions = true;
        const hasbiannuallyCompare = !!(
          priceData.biannuallyOnetimeComparePrice &&
          priceData.biannuallyOnetimeComparePrice !== "Unavailable" &&
          priceData.biannuallyOnetimeComparePrice !==
            priceData.biannuallyOnetimePrice
        );

        contentHTML += `
          <div class="subscription-option biannually-option ${ selectedOption === 'biannually' ? "selected" : ""}">
            <div class="option-row">
              <input type="radio" name="subscription-option" id="biannually-onetime" class="subscription-radio"
                    data-plan="biannually-onetime"
                    data-variant-id="${priceData.biannuallyOnetimeVariantId}"
                    data-product-variant="biannually-onetime"
                    data-product-variant-price="${
                      priceData.biannuallyOnetimePriceRaw
                    }"
                    ${ selectedOption === 'biannually' ? "checked": "" }>
              <label for="biannually-onetime">${
                textConstants.sixMonthsSupplyText
              }</label>
              
              <div class="price-per-day txt2">${ this.getPriceperdayText("biannuallyOnetime")} ${this.perDayText}</div>
            </div>
            <div class="price-discount-container">
              <div class="pricing">
                ${
                  hasbiannuallyCompare
                    ? `<span class="original-price">${priceData.biannuallyOnetimeComparePrice}</span>`
                    : ""
                }
                <span class="current-price">${
                  priceData.biannuallyOnetimePrice
                }</span>
              </div>
              ${
                priceData.discountbiannuallyOnetimeText && hasbiannuallyCompare
                  ? `<div class="discount-badge">${textConstants.saveText} ${priceData.discountbiannuallyOnetimeText}</div>`
                  : ""
              }
            </div>
            ${this.renderBenefits("biannuallyOnetime")}
          </div>`;
      }

      // Only show subscription option if at least one variant is available
      if (monthlySubAvailable || biannuallySubAvailable) {
        contentHTML += `
          <div class="subscribe-option">
            <span>${textConstants.subscribeAndSaveText}</span>
            <span class="subscribe-price">${textConstants.startingAtText} ${
          monthlySubAvailable
            ? priceData.monthly_discounted_price
            : biannuallySubAvailable
            ? priceData.biannually_discounted_price
            : ""
        }</span>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M12 8V16M8 12H16M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" stroke="#0C240E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
            </svg>
          </div>`;
      } else {
        console.log(
          "[KADESO WARNING] No subscription variants available, hiding option"
        );
      }
      
      if (currentModeHasOptions) {
        var initialOneTimePrice;
        
        if (selectedOption == 'monthly') {
          initialOneTimePrice = priceData.monthlyOnetimePrice;
        } else if (selectedOption == 'quarterly') {
          initialOneTimePrice = priceData.quarterlyOnetimePrice;
        } else if (selectedOption == 'biannually') {
          initialOneTimePrice = priceData.biannuallyOnetimePrice;
        }
        
        contentHTML += `
          <div class="btn-container"><button class="custom-subscribe-button ngoc1" ${
            initialOneTimePrice === "Unavailable" ? "disabled" : ""
          }><img src="https://cdn.shopify.com/s/files/1/0780/6071/6356/files/arrow-trend-up-svgrepo-com_1.svg"> 
            ${textConstants.addToCartText} ${initialOneTimePrice} <img src="https://cdn.shopify.com/s/files/1/0780/6071/6356/files/arrow-trend-up-svgrepo-com_1.svg"> 
          </button></div>`;
      }
    }

    console.log("[KADESO DEBUG] Current mode has options check:", {
      currentModeHasOptions,
      mode: this.mode,
      monthlyOneTimeAvailable,
      quarterlyOneTimeAvailable,
      biannuallyOneTimeAvailable,
      monthlySubAvailable,
      quarterlySubAvailable,
      biannuallySubAvailable,
      language: this.currentLanguage,
      contentHTML: contentHTML.substring(0, 100) + "...", // Show the first 100 chars of the content
    });

    if (!currentModeHasOptions) {
      contentHTML = `<p class="kadeso-error">${textConstants.optionsUnavailableText}</p>`;
    }

    customContainer.innerHTML = contentHTML;
    this.placeholder.innerHTML = "";
    this.placeholder.appendChild(customContainer);
    this.customContainer = customContainer;

    requestAnimationFrame(() => this.showBenefits());
  }

  getUITextConstants() {
    const isEnglish = this.currentLanguage === "english";
    return {
      subscribeAndSaveText: isEnglish
        ? "Subscribe & Save"
        : "Abonneer & Bespaar",
      oneTimePurchaseText: isEnglish
        ? "ONE-TIME PURCHASE"
        : "EENMALIGE AANKOOP",
      mostPopularText: isEnglish ? "Most Chosen" : "Meest gekozen",
      bestValueText: isEnglish ? "Best value" : "Beste waarde",
      oneMonthSupplyText: isEnglish ? "1-month supply" : "1-maand voorraad",
      threeMonthsSupplyText: isEnglish
        ? "3-months supply"
        : "3-maanden voorraad",
      sixMonthsSupplyText: isEnglish
        ? "6-months supply"
        : "6-maanden voorraad",
      saveText: isEnglish ? "Save" : "Bespaar",
      oneTimePurchaseOptionText: isEnglish
        ? "One-time purchase"
        : "Eenmalige aankoop",
      startingAtText: isEnglish ? "Starting at" : "Vanaf",
      subscribeText: isEnglish ? "SUBSCRIBE" : "ABONNEREN",
      addToCartText: isEnglish ? "ADD TO CART" : "IN WINKELWAGEN",
      freeShippingText: isEnglish
        ? "Free shipping. Swap, skip or cancel anytime."
        : "Gratis verzending. Wissel, sla over of annuleer op elk moment.",
      unavailableText: isEnglish
        ? "This product is currently unavailable."
        : "Dit product is momenteel niet beschikbaar.",
      optionsUnavailableText: isEnglish
        ? "These options are currently unavailable."
        : "Deze opties zijn momenteel niet beschikbaar.",
    };
  }

  buildMonthlySubscriptionHTML(
    priceData,
    selectedOption,
    mostPopularText,
    saveText
  ) {
    return `
      <div class="subscription-option monthly-option ${
        selectedOption === 'monthly' ? "selected" : ""
      }">
        <div class="option-row">
          <input type="radio" name="subscription-option" id="monthly-option" class="subscription-radio"
                data-plan="monthly"
                data-variant-id="${priceData.monthlyVariantId}"
                data-product-variant="monthly"
                data-product-variant-price="${priceData.monthlyPriceRaw}"
                ${selectedOption === 'monthly' ? "checked" : ""}>
          <label for="monthly-option">${this.sellingPlans.monthly.name}</label>
          <div class="price-per-day txt3">${ this.getPriceperdayText("monthly")} ${this.perDayText}</div>
        </div>
        <div class="price-discount-container">
          <div class="pricing">
            ${
              priceData.discountMonthlyText
                ? `<span class="original-price">${priceData.monthlyPrice}</span>`
                : ""
            }
            <span class="current-price">${
              priceData.monthly_discounted_price
            }</span>
          </div>
          ${
            priceData.discountMonthlyText
              ? `<div class="discount-badge">${saveText} ${priceData.discountMonthlyText}</div>`
              : ""
          }
        </div>
        ${this.renderBenefits("monthly")}
      </div>`;
  }

  buildQuarterlySubscriptionHTML(
    priceData,
    selectedOption,
    quarterlySubAvailable,
    bestValueText,
    saveText
  ) {
    return `
      <div class="subscription-option quarterly-option ${
        selectedOption === 'quarterly' ? "selected" : ""
      }">
        <div class="option-tag">${bestValueText}</div>
        <div class="option-row">
          <input type="radio" name="subscription-option" id="quarterly-option" class="subscription-radio"
                data-plan="quarterly"
                data-variant-id="${priceData.quarterlyVariantId}"
                data-product-variant="quarterly"
                data-product-variant-price="${priceData.quarterlyPriceRaw}"
                ${ selectedOption === 'quarterly' ? "checked" : ""}>
          <label for="quarterly-option">${
            this.sellingPlans.quarterly.name
          }</label>
          <div class="price-per-day txt4">${ this.getPriceperdayText("quarterly")} ${this.perDayText}</div>
        </div>
        <div class="price-discount-container">
          <div class="pricing">
            ${
              priceData.discountQuarterlyText
                ? `<span class="original-price">${priceData.quarterlyPrice}</span>`
                : ""
            }
            <span class="current-price">${
              priceData.quarterly_discounted_price
            }</span>
          </div>
          ${
            priceData.discountQuarterlyText
              ? `<div class="discount-badge">${saveText} ${priceData.discountQuarterlyText}</div>`
              : ""
          }
        </div>
        ${this.renderBenefits("quarterly")}
      </div>`;
  }

  buildOneTimeOptionHTML(
    oneTimePurchaseOptionText,
    startingAtText,
    monthlyPrice,
    quarterlyPrice,
    biannuallyPrice
  ) {
    return `
      <div class="one-time-option">
        <span>${oneTimePurchaseOptionText}</span>
        <span class="one-time-price">${startingAtText} ${
      monthlyPrice || quarterlyPrice || biannuallyPrice ||  ""
    }</span>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M12 8V16M8 12H16M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" stroke="#0C240E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
        </svg>
      </div>`;
  }

  connectEvents(priceData) {
    if (!this.customContainer) return;

    const radioButtons = this.customContainer.querySelectorAll(
      ".subscription-radio"
    );
    const subscribeButton = this.customContainer.querySelector(
      ".custom-subscribe-button"
    );
    const optionCards = this.customContainer.querySelectorAll(
      ".subscription-option"
    );
    const oneTimeOption =
      this.customContainer.querySelector(".one-time-option");
    const subscribeOption =
      this.customContainer.querySelector(".subscribe-option");

    const sealMonthlyRadio = document.querySelector('.sls-option[value="0"]');
    const sealQuarterlyRadio = document.querySelector('.sls-option[value="1"]');
    const sealOneTimeRadio = document.querySelector(
      '.sls-option[value="one_time"]'
    );

    this.customContainer.addEventListener("click", (e) => {
      const card = e.target.closest(".subscription-option");
      if (card) {
        if (
          e.target.type === "radio" ||
          card.querySelector('input[type="radio"]:disabled')
        ) {
          return;
        }

        const radio = card.querySelector(".subscription-radio");
        if (radio && !radio.checked) {
          radio.checked = true;
          radio.dispatchEvent(new Event("change", { bubbles: true }));
        }
      }
    });

    const handleRadioChange = (radio) => {
      if (!radio.checked) return;

      console.log('handleRadioChange clicked');
      
      const planType = radio.getAttribute("data-plan");
      const variantId = radio.getAttribute("data-variant-id");

      console.log('variantId = ', variantId);
      console.log('planType = ', planType);
      
      optionCards.forEach((card) => card.classList.remove("selected"));
      const parentCard = radio.closest(".subscription-option");
      if (parentCard) parentCard.classList.add("selected");

      this.showBenefits();

      if (subscribeButton) {
        let currentPrice = "Unavailable";
        if (this.mode === "subscription") {
          if (planType === "monthly") {
            currentPrice = priceData.monthly_discounted_price;
            const subscribeText =
              this.currentLanguage === "english" ? "SUBSCRIBE" : "ABONNEREN";
            subscribeButton.textContent = `${subscribeText} ${currentPrice}`;
            if (sealMonthlyRadio && !sealMonthlyRadio.checked)
              sealMonthlyRadio.click();
            this.updateSellingPlanInput(this.sellingPlans.monthly.id || "");
            
          } else if (planType == 'quarterly') {
            currentPrice = priceData.quarterly_discounted_price;
            const subscribeText =
              this.currentLanguage === "english" ? "SUBSCRIBE" : "ABONNEREN";
            subscribeButton.textContent = `${subscribeText} ${currentPrice}`;
            if (sealQuarterlyRadio && !sealQuarterlyRadio.checked)
              sealQuarterlyRadio.click();
            this.updateSellingPlanInput(this.sellingPlans.quarterly.id || "");
            
          } else if (planType == 'biannually') {
            currentPrice = priceData.biannually_discounted_price;
            const subscribeText =
              this.currentLanguage === "english" ? "SUBSCRIBE" : "ABONNEREN";
            subscribeButton.textContent = `${subscribeText} ${currentPrice}`;
            if (sealbiannuallyRadio && !sealbiannuallyRadio.checked)
              sealbiannuallyRadio.click();
            this.updateSellingPlanInput(this.sellingPlans.quarterly.id || "");
          }
        } else {
          if (planType == 'monthly-onetime') {
            currentPrice = priceData.monthlyOnetimePrice;
          } else if (planType == 'quarterly-onetime') {
            currentPrice = priceData.quarterlyOnetimePrice;
          } else if (planType == 'biannually-onetime') {
            currentPrice = priceData.biannuallyOnetimePrice;
          }
          
          const addToCartText =
            this.currentLanguage === "english"
              ? "ADD TO CART"
              : "IN WINKELWAGEN";
          subscribeButton.textContent = `${addToCartText} ${currentPrice}`;
          if (sealOneTimeRadio && !sealOneTimeRadio.checked)
            sealOneTimeRadio.click();
          this.updateSellingPlanInput("");
        }
        console.log('currentPrice = ', currentPrice)
        subscribeButton.disabled = currentPrice === "Unavailable";
      }

      if (this.variantIdInput && variantId) {
        this.variantIdInput.value = variantId;
      }
    };

    radioButtons.forEach((radio) => {
      radio.addEventListener("change", () => handleRadioChange(radio));
    });

    if (oneTimeOption) {
      oneTimeOption.addEventListener("click", () => {
        if (this.mode === "onetime") return;
        this.mode = "onetime";

        // Switching to one-time purchase mode

        const newPriceData = this.getFormattedPriceData();
        this.createCustomUI(newPriceData);
        this.connectEvents(newPriceData);

        requestAnimationFrame(() => {
          if (sealOneTimeRadio) sealOneTimeRadio.click();
          this.updateSellingPlanInput("");

          const firstOneTimeRadio = this.customContainer.querySelector(
            '.subscription-radio[data-plan="monthly-onetime"]'
          );
          if (firstOneTimeRadio && !firstOneTimeRadio.disabled) {
            // Selecting monthly one-time variant
            firstOneTimeRadio.checked = true;
            firstOneTimeRadio.dispatchEvent(
              new Event("change", { bubbles: true })
            );
          } else {
            const secondOneTimeRadio = this.customContainer.querySelector(
              '.subscription-radio[data-plan="quarterly-onetime"]'
            );
            if (secondOneTimeRadio && !secondOneTimeRadio.disabled) {
              // Selecting quarterly one-time variant
              secondOneTimeRadio.checked = true;
              secondOneTimeRadio.dispatchEvent(
                new Event("change", { bubbles: true })
              );
            }
          }
        });
      });
    }

    if (subscribeOption) {
      subscribeOption.addEventListener("click", () => {
        if (this.mode === "subscription") return;
        this.mode = "subscription";

        const newPriceData = this.getFormattedPriceData();
        this.createCustomUI(newPriceData);
        this.connectEvents(newPriceData);

        requestAnimationFrame(() => {
          const firstSubRadio = this.customContainer.querySelector(
            '.subscription-radio[data-plan="monthly"]'
          );
          if (firstSubRadio && !firstSubRadio.disabled) {
            firstSubRadio.checked = true;
            firstSubRadio.dispatchEvent(new Event("change", { bubbles: true }));
          } else {
            const secondSubRadio = this.customContainer.querySelector(
              '.subscription-radio[data-plan="quarterly"]'
            );
            if (secondSubRadio && !secondSubRadio.disabled) {
              secondSubRadio.checked = true;
              secondSubRadio.dispatchEvent(
                new Event("change", { bubbles: true })
              );
            } else {
              if (sealMonthlyRadio) sealMonthlyRadio.click();
              this.updateSellingPlanInput(this.sellingPlans.monthly.id || "");
              if (this.variantIdInput && newPriceData.monthlyVariantId) {
                this.variantIdInput.value = newPriceData.monthlyVariantId;
              }
            }
          }
        });
      });
    }

    if (subscribeButton) {
      subscribeButton.addEventListener("click", (e) => {
        e.preventDefault();

        console.log('subscribeButton is clicked ---------------------------------------- ');
        
        if (subscribeButton.disabled) return;

        const selectedRadio = this.customContainer.querySelector(
          ".subscription-radio:checked"
        );

        if (!selectedRadio) {
          const selectOptionText =
            this.currentLanguage === "english"
              ? "Please select an option before adding to cart."
              : "Selecteer een optie voordat je aan winkelwagen toevoegt.";
          alert(selectOptionText);
          return;
        }

        const planType = selectedRadio.getAttribute("data-plan");
        const variantId = selectedRadio.getAttribute("data-variant-id");

        if (!variantId || variantId === "null" || variantId === "undefined") {
          const refreshText =
            this.currentLanguage === "english"
              ? "There was an issue selecting this option. Please try refreshing the page."
              : "Er was een probleem bij het selecteren van deze optie. Vernieuw de pagina en probeer het opnieuw.";
          alert(refreshText);
          return;
        }

        if (!this.variantIdInput) {
          this.variantIdInput = document.querySelector('input[name="id"]');

          if (!this.variantIdInput && this.originalForm) {
            const input = document.createElement("input");
            input.type = "hidden";
            input.name = "id";
            this.originalForm.appendChild(input);
            this.variantIdInput = input;
          }
        }

        if (!this.variantIdInput) {
          const refreshText =
            this.currentLanguage === "english"
              ? "There was an error preparing your selection. Please try refreshing the page."
              : "Er is een fout opgetreden bij het voorbereiden van je selectie. Vernieuw de pagina en probeer het opnieuw.";
          alert(refreshText);
          return;
        }

        let planId = "";
        if (this.mode === "subscription") {
          planId =
            planType === "monthly"
              ? this.sellingPlans.monthly.id || ""
              : this.sellingPlans.quarterly.id || "";

          if (!planId) {
            const missingPlanText =
              this.currentLanguage === "english"
                ? "Subscription plan details are missing. Cannot add to cart. Please contact support."
                : "Abonnementsgegevens ontbreken. Kan niet toevoegen aan winkelwagen. Neem contact op met support.";
            alert(missingPlanText);
            return;
          }

          if (planType === "monthly") {
            if (sealMonthlyRadio && !sealMonthlyRadio.checked)
              sealMonthlyRadio.click();
          } else {
            if (sealQuarterlyRadio && !sealQuarterlyRadio.checked)
              sealQuarterlyRadio.click();
          }
        } else if (sealOneTimeRadio && !sealOneTimeRadio.checked) {
          sealOneTimeRadio.click();
        }

        // Adding to cart
        console.log("[KADESO DEBUG] Adding to cart:", {
          variantId,
          planId,
          mode: this.mode,
          planType,
          language: this.currentLanguage,
          variant: this.productData.variants.find((v) => v.id === variantId),
          isOneTimeVariant:
            planType === "monthly-onetime" || planType === "quarterly-onetime",
          isSubscriptionVariant:
            planType === "monthly" || planType === "quarterly",
        });

        this.variantIdInput.value = variantId;
        this.updateSellingPlanInput(planId);

        const addingText =
          this.currentLanguage === "english" ? "ADDING..." : "TOEVOEGEN...";
        subscribeButton.textContent = addingText;
        subscribeButton.disabled = true;

        if (!this.addToCartButton) {
          this.addToCartButton =
            this.originalForm?.querySelector('[type="submit"]') ||
            document.querySelector("[data-btn-addtocart]") ||
            this.originalForm?.querySelector('button[name="add"]');
        }

        setTimeout(() => {
          try {
            if (this.addToCartButton) {
              console.log('addToCartButton clicked--------------------------------');
              this.addToCartButton.disabled = false;
              this.addToCartButton.click();

              /*
              window.location.href = '/checkout';
*/
              
            } else if (this.originalForm) {
              console.log('originalForm submitted --------------------------------');
              this.originalForm.submit();
            } else {
              const cartErrorText =
                this.currentLanguage === "english"
                  ? "Could not add item to cart. Please try again or contact support."
                  : "Kon item niet aan winkelwagen toevoegen. Probeer het opnieuw of neem contact op met support.";
              alert(cartErrorText);

              const currentPriceText =
                selectedRadio
                  .closest(".subscription-option")
                  ?.querySelector(".current-price")?.textContent || "";
              const buttonText =
                this.mode === "subscription"
                  ? this.currentLanguage === "english"
                    ? "SUBSCRIBE"
                    : "ABONNEREN"
                  : this.currentLanguage === "english"
                  ? "ADD TO CART"
                  : "IN WINKELWAGEN";

              subscribeButton.textContent = `${buttonText} ${currentPriceText}`;
              subscribeButton.disabled = currentPriceText === "Unavailable";
            }
          } catch (e) {
            const cartErrorText =
              this.currentLanguage === "english"
                ? "Could not add item to cart. Please try again or contact support."
                : "Kon item niet aan winkelwagen toevoegen. Probeer het opnieuw of neem contact op met support.";
            alert(cartErrorText);

            const currentPriceText =
              selectedRadio
                .closest(".subscription-option")
                ?.querySelector(".current-price")?.textContent || "";
            const buttonText =
              this.mode === "subscription"
                ? this.currentLanguage === "english"
                  ? "SUBSCRIBE"
                  : "ABONNEREN"
                : this.currentLanguage === "english"
                ? "ADD TO CART"
                : "IN WINKELWAGEN";

            subscribeButton.textContent = `${buttonText} ${currentPriceText}`;
            subscribeButton.disabled = currentPriceText === "Unavailable";
          }
        }, 150);
      });
    }
  }

  showBenefits() {
    if (!this.customContainer) return;
    const allOptions = this.customContainer.querySelectorAll(
      ".subscription-option"
    );

    allOptions.forEach((option) => {
      const benefitsContainer = option.querySelector(".benefits-container");
      if (benefitsContainer) {
        if (option.classList.contains("selected")) {
          benefitsContainer.style.maxHeight =
            benefitsContainer.scrollHeight + "px";
        } else {
          benefitsContainer.style.maxHeight = "0";
        }
      }
    });
  }

  updateSellingPlanInput(planId) {
    console.log('updateSellingPlanInput ----------------------------------- ');
    
    if (!this.sellingPlanInput) {
      this.sellingPlanInput =
        document.querySelector('input[name="selling_plan"]') ||
        document.querySelector("input[data-sls-selling_plan]");
    }

    if (
      !this.sellingPlanInput &&
      this.originalForm &&
      this.mode === "subscription"
    ) {
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = "selling_plan";
      this.originalForm.appendChild(input);
      this.sellingPlanInput = input;
    }

    if (this.sellingPlanInput) {
      this.sellingPlanInput.value = planId || "";
    }

    const otherInputs = document.querySelectorAll(
      'input[name="selling_plan"]:not(:first-child), input[data-sls-selling_plan]:not(:first-child)'
    );
    otherInputs.forEach((input) => {
      input.value = planId || "";
    });
  }

  hideStandardProductControls() {
    const elementsToHide = [
      ".productView-moreItem-product-variant",
      '[data-type="buy_buttons"]',
      ".product-form__buttons",
      ".product-form__input",
      ".product__description",
      ".product-variant-id",
      ".product-variants",
      ".variant-picker",
      ".product-form__quantity",
      ".product__price",
    ];

    let styleSheet = document.getElementById("kadeso-hide-styles");
    if (!styleSheet) {
      styleSheet = document.createElement("style");
      styleSheet.id = "kadeso-hide-styles";
      document.head.appendChild(styleSheet);
    }

    const cssRules = [
      ...elementsToHide.map(
        (selector) => `${selector} { display: none !important; }`
      ),
      `.sealsubs-container {
        opacity: 0 !important;
        position: absolute !important;
        z-index: -1 !important;
        pointer-events: none !important;
        height: 0 !important;
        overflow: hidden !important;
        visibility: hidden !important;
      }`,
      `.sealsubs-container * {
        margin: 0 !important;
        display: block !important;
        visibility: hidden !important;
      }`,
    ].join(" ");

    styleSheet.textContent = cssRules;
  }

  parsePrice(priceVal) {
    // Parse price value
    if (priceVal === null || typeof priceVal === "undefined") return NaN;
    let numValue = NaN;
    if (typeof priceVal === "number") {
      numValue = priceVal / 100.0;
    } else if (typeof priceVal === "string") {
      const numericString = priceVal.replace(/[^\d.,]/g, "").replace(",", ".");
      numValue = parseFloat(numericString);
    }
    return isNaN(numValue) ? NaN : numValue;
  }

  formatPrice(value) {
    let numValue = value;
    if (typeof numValue !== "number") {
      numValue = parseFloat(numValue);
    }
    if (isNaN(numValue)) return "Unavailable";

    const options = { style: "currency", currency: "EUR" };
    try {
      // Use the appropriate locale based on the current language
      const locale = this.currentLanguage === "dutch" ? "nl-NL" : "en-US";
      return numValue.toLocaleString(locale, options);
    } catch (e) {
      return `€${numValue.toFixed(2)}`;
    }
  }

  getCurrencySymbol(priceStr) {
    if (typeof priceStr !== "string") return "€";
    const symbol = priceStr.replace(/[\d.,\s]/g, "");
    return symbol || "€";
  }

  setupLanguageChangeListener() {
    document.addEventListener(
      "shopify:language:change",
      this.handleLanguageChange.bind(this)
    );

    const languageObserver = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (
          mutation.type === "attributes" &&
          (mutation.attributeName === "lang" ||
            mutation.attributeName === "data-language")
        ) {
          this.handleLanguageChange();
          break;
        }
      }
    });

    languageObserver.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["lang"],
    });

    const languageSelectors = document.querySelectorAll(
      ".disclosure__link, [data-value], .localization-selector, .localization-form__select, #HeaderLanguageForm, #HeaderLanguageList a"
    );
    languageSelectors.forEach((selector) => {
      selector.addEventListener("click", () => {
        setTimeout(() => this.handleLanguageChange(), 500);
      });
    });

    const languageForms = document.querySelectorAll(
      'form[action="/localization"], #HeaderLanguageForm, .localization-form'
    );
    languageForms.forEach((form) => {
      form.addEventListener("submit", () => {
        setTimeout(() => this.handleLanguageChange(), 1000);
      });
    });
  }

  handleLanguageChange() {
    const newLanguage = this.detectLanguage();

    if (newLanguage !== this.currentLanguage) {
      this.currentLanguage = newLanguage;

      this.sellingPlans.monthly.name =
        this.currentLanguage === "english"
          ? "1-month supply"
          : "1-maand voorraad";

      this.sellingPlans.quarterly.name =
        this.currentLanguage === "english"
          ? "3-months supply"
          : "3-maanden voorraad";

      if (this.initialized) {
        // Force reload product data on language change
        this.loadProductData().then((success) => {
          if (!success) {
            // If direct load fails, try fallback
            this.fallbackLoadProduct().then((_) => {
              this.refreshUI();
            });
          } else {
            this.refreshUI();
          }
        });
      }
    }
  }

  refreshUI() {    
    this.getCurrentVariantPrices();
    const priceData = this.getFormattedPriceData();

    if (priceData) {
      this.createCustomUI(priceData);
      this.connectEvents(priceData);
    }
  }

  addCustomStyles() {
    if (document.getElementById("kadeso-custom-styles")) return;

    const styleEl = document.createElement("style");
    styleEl.id = "kadeso-custom-styles";
    document.head.appendChild(styleEl);

    requestAnimationFrame(() => {
      styleEl.textContent = `
        .kadeso-subscription-container {
          margin-top: var(--kadeso-spacing-top, 20px);
          margin-bottom: var(--kadeso-spacing-bottom, 20px);
          opacity: 1; transition: opacity 0.3s ease-in-out;
        }
        .kadeso-subscription-placeholder:empty + .kadeso-subscription-container { opacity: 0; }
        .subscription-header { font-size: 3rem; margin-bottom: 15px; color: var(--kadeso-heading-color); }
        .subscription-option {
          border: 2px solid #e0e0e0; border-radius: 8px; padding: 16px; margin-bottom: 25px;
          position: relative; background-color: #ffffff; cursor: pointer;
          transition: border-color 0.2s ease-in-out, background-color 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
        }
        .subscription-option:hover { border-color: #c0c0c0; }
        .subscription-option.selected {
          border-color: var(--kadeso-active-border-color, #006633);
          background-color: var(--kadeso-selected-box-color, #f9f9f9); box-shadow: 0 2px 5px rgba(0, 102, 51, 0.1);
        }
        .selected .benefits-container {
          border-top: 1px solid rgba(0, 0, 0, 0.1);
        }
        .subscription-option input[type="radio"]:disabled + label { color: #999; cursor: not-allowed; }
        .subscription-option input[type="radio"]:disabled ~ .pricing .current-price,
        .subscription-option input[type="radio"]:disabled ~ .pricing .original-price,
        .subscription-option input[type="radio"]:disabled ~ .price-per-day,
        .subscription-option input[type="radio"]:disabled ~ .discount-badge { opacity: 0.6; }
        .subscription-option input[type="radio"]:disabled { cursor: not-allowed; border-color: #ccc !important; }
        .subscription-option input[type="radio"]:disabled:after { background-color: #ccc !important; }
        .option-row {
            display: flex;
            align-items: center;
        }
        .option-row label { font-size: 2rem; font-weight: 600; color: var(--kadeso-heading-color, #333); margin: 0; flex-grow: 1; padding-left: 5px; }
        .pricing { margin-left: auto; text-align: right; white-space: nowrap; padding-left: 10px; }
        .original-price { font-size: 1.4rem; text-decoration: line-through; color: #888; margin-right: 5px; }
        .current-price { font-size: 2rem; font-weight: 600; color: var(--kadeso-heading-color, #333); font-size: 1.4rem;     color: #888; }
        .option-tag {
          background-color: var(--kadeso-active-border-color, #006633); color: var(--kadeso-button-text-color, #fff);
          position: absolute; top: -15px; right: 15px; padding: 2px 10px; border-radius: 12px;
          font-weight: 500; font-size: 1.4rem; line-height: 1.5;
        }
        .subscription-option.quarterly-option .option-tag { background-color: #000; color: #fff!important; }
        .price-discount-container {
          display: flex;
          flex-direction: row-reverse;
          justify-content: space-between;
          align-items: center;
          margin-top: 5px;
          margin-bottom: 5px;
        }
        .discount-badge {
          display: inline-block; background-color: var(--kadeso-discount-badge-bg-color, #ffcc00); color: var(--kadeso-discount-badge-text-color, #333);
          padding: 2px 8px; border-radius: 12px; font-weight: 500; font-size: 1.4rem;
          margin-top: 6px; margin-left: 34px; line-height: 1.5;
        }
        .price-per-day {
          color: #555;
          font-size: 1.4rem;
          text-align: right;
          line-height: 1.5;
          right: 17px;
          top: 4.5rem;
          font-size: 2rem;
          font-weight: bold;
          color: #000;
        }
        .benefits-container {
          max-height: 0; overflow: hidden; transition: max-height 0.3s ease-out;
        }
        .selected .benefits-container {
          padding-top: 10px; max-height: 0; overflow: hidden; transition: max-height 0.3s ease-out;
        }
        .subscription-option.selected .benefits-container { max-height: 120px; }
        .benefit { position: relative; padding-left: 25px; margin-bottom: 6px; line-height: 1.4; color: #333; font-size: 1.4rem; }
        .benefit:before {
          content: ""; position: absolute; left: 0; top: 3px; width: 16px; height: 16px; background-color: #ccc;
          border-radius: 50%; background-size: 9px; background-position: center; background-repeat: no-repeat;
        }
        .benefit.orange-dot:before { background-color: var(--kadeso-bullet-color, #ff6600); }
        .benefit.cycle-icon:before { background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23ffffff' viewBox='0 0 16 16'%3E%3Cpath fill-rule='evenodd' d='M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z'/%3E%3Cpath d='M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z'/%3E%3C/svg%3E"); background-color: #666; }
        .benefit.clock-icon:before { background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23ffffff' viewBox='0 0 16 16'%3E%3Cpath d='M8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71V3.5z'/%3E%3Cpath d='M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm7-8A7 7 0 1 1 1 8a7 7 0 0 1 14 0z'/%3E%3C/svg%3E"); background-color: #666; }
        .one-time-option, .subscribe-option {
          font-size: 2rem; background-color: #f8f9fa; padding: 15px; border-radius: 8px; display: flex; align-items: center;
          margin-bottom: 20px; cursor: pointer; border: 2px solid #e0e0e0;
          transition: border-color 0.2s ease-in-out, background-color 0.2s ease-in-out; font-weight: 500; color: #333;
        }
        .one-time-option:hover, .subscribe-option:hover { border-color: var(--kadeso-active-border-color, #006633); background-color: #f0f0f0; }
        .one-time-price, .subscribe-price { margin-left: auto; margin-right: 10px; font-weight: 600; color: var(--kadeso-heading-color, #333); }
        .one-time-icon, .subscribe-icon { margin-left: 5px; color: var(--kadeso-active-border-color, #006633); }
        .custom-subscribe-button {
          font-size: 2rem; background-color: var(--kadeso-button-bg-color, #006633); color: var(--kadeso-button-text-color, #fff);
          width: 100%; padding: 14px; border: none; border-radius: 8px; font-weight: 600; cursor: pointer; text-align: center; margin-bottom: 10px;
          transition: background-color 0.2s ease-in-out, opacity 0.2s ease-in-out;
        }
        .custom-subscribe-button:hover:not(:disabled) { background-color: var(--kadeso-button-bg-hover-color, #004d26); }
        .custom-subscribe-button:disabled { background-color: #a0a0a0; opacity: 0.7; cursor: not-allowed; }
        .delivery-note { text-align: center; color: #666; font-size: 1.4rem; }
        .subscription-radio {
          appearance: none !important; -webkit-appearance: none !important; width: 20px !important; height: 20px !important;
          border: 2px solid #999 !important; border-radius: 50% !important; outline: none !important; margin-right: 12px !important;
          position: relative !important; display: inline-block !important; opacity: 1 !important; visibility: visible !important;
          pointer-events: auto !important; cursor: pointer; flex-shrink: 0; transition: border-color 0.2s ease-in-out;
        }
        .subscription-radio:checked { border-color: var(--kadeso-active-border-color, #006633) !important; }
        .subscription-radio:checked:after {
          content: "" !important; position: absolute !important; top: 50% !important; left: 50% !important;
          transform: translate(-50%, -50%) !important; width: 10px !important; height: 10px !important;
          background-color: var(--kadeso-active-border-color, #006633) !important; border-radius: 50% !important; display: block !important;
        }
        .kadeso-loading { text-align: center; padding: 30px; color: #666; }
        .kadeso-error { text-align: center; padding: 20px; color: #cc0000; font-weight: 500; }

        @media (max-width: 1024px) and (min-width: 768px) {
          .option-row label {
            font-size: 1.8rem;
          }
          .price-per-day {
            top: 5rem;
          }
        }
        @media (max-width: 767px) {
          .subscription-header { font-size: 2.4rem; }
          .option-row label { font-size: 1.6rem; }
          .current-price, .original-price { font-size: 1.2rem; }
          .price-per-day { font-size: 1.4rem; top: 4.8rem; }
          .discount-badge { font-size: 1.2rem; }
          .benefit { font-size: 1.3rem; }
          .one-time-option, .subscribe-option { font-size: 1.6rem; }
          .custom-subscribe-button { font-size: 1.6rem; }
          .delivery-note { font-size: 1.2rem; }
        }
      `;
    });
  }
}

(function () {
  if (window.kadesoInitializing) {
    return;
  }

  let kadesoRetryCount = 0;
  const maxRetries = 10;
  let kadesoInitTimer = null;

  function handleGlobalLanguageChange() {
    if (
      window.enhancedKadesoInstance &&
      window.enhancedKadesoInstance.initialized
    ) {
      window.enhancedKadesoInstance.handleLanguageChange();
    }
  }

  document.addEventListener(
    "shopify:language:change",
    handleGlobalLanguageChange
  );
  window.addEventListener("languageChanged", handleGlobalLanguageChange);

  setInterval(() => {
    if (
      window.enhancedKadesoInstance &&
      window.enhancedKadesoInstance.initialized
    ) {
      window.enhancedKadesoInstance.handleLanguageChange();
    }
  }, 5000);

  function hideDefaultControls() {
    const elementsToHide = [
      ".productView-moreItem-product-variant",
      '[data-type="buy_buttons"]',
      ".product-form__buttons",
      ".product-form__input",
      ".product__description",
      ".product-variant-id",
      ".product-variants",
      ".variant-picker",
      ".product-form__quantity",
      ".product__price",
      ".sealsubs-container",
    ];

    const styleSheet = document.createElement("style");
    styleSheet.id = "kadeso-hide-styles";

    const cssRules = elementsToHide
      .map((selector) => {
        if (selector === ".sealsubs-container") {
          return `
          ${selector} {
            height: 0 !important; overflow: hidden !important; visibility: hidden !important;
            opacity: 0 !important; position: absolute !important; z-index: -1 !important;
            pointer-events: none !important; margin: 0 !important; padding: 0 !important;
            border: none !important;
          }
        `;
        } else {
          return `${selector} { display: none !important; }`;
        }
      })
      .join("");

    styleSheet.textContent = cssRules;
    document.head.appendChild(styleSheet);
  }

  function initSubscription() {
    if (window.kadesoInitializing) {
      return;
    }

    if (window.enhancedKadesoInstance) {
      window.enhancedKadesoInstance = null;
    }

    kadesoRetryCount++;
    window.kadesoAttempts = kadesoRetryCount;

    const subscriptionBlock = document.querySelector(".subscription-block");
    const placeholder = document.querySelector(
      ".kadeso-subscription-placeholder"
    );

    if (subscriptionBlock && placeholder) {
      placeholder.innerHTML =
        '<div class="kadeso-loading">Loading product data...</div>';
      window.enhancedKadesoInstance = new EnhancedKadesoSubscription();
    } else if (kadesoRetryCount < maxRetries) {
      const delay = Math.min(
        Math.random() * 100 + 150 * Math.pow(1.5, kadesoRetryCount - 1),
        2000
      );
      kadesoInitTimer = setTimeout(initSubscription, delay);
    }
  }

  function scheduleEmergencyCheck() {
    setTimeout(() => {
      if (window.kadesoInitializing) {
        // KadesoSubscription: Initialization timed out, forcing restart
        window.kadesoInitializing = false;

        if (window.enhancedKadesoInstance) {
          try {
            if (Array.isArray(window.enhancedKadesoInstance.timeouts)) {
              window.enhancedKadesoInstance.timeouts.forEach((t) =>
                clearTimeout(t)
              );
            }
          } catch (e) {}
        }

        window.enhancedKadesoInstance = null;
        initSubscription();
      }
    }, 8000);
  }

  if (document.readyState === "loading") {
    hideDefaultControls();
    document.addEventListener("DOMContentLoaded", () => {
      initSubscription();
      scheduleEmergencyCheck();
    });
  } else {
    hideDefaultControls();
    initSubscription();
    scheduleEmergencyCheck();
  }

  document.addEventListener("shopify:section:load", () => {
    setTimeout(() => {
      if (
        !window.enhancedKadesoInstance ||
        !window.enhancedKadesoInstance.initialized
      ) {
        window.kadesoInitializing = false;
        kadesoRetryCount = 0;
        initSubscription();
      }
    }, 300);
  });

  if (typeof MutationObserver === "function") {
    const observer = new MutationObserver((mutations) => {
      if (window.kadesoInitializing) return;
      if (
        window.enhancedKadesoInstance &&
        window.enhancedKadesoInstance.initialized
      )
        return;

      let relevantChange = false;

      for (const mutation of mutations) {
        if (mutation.type === "childList") {
          const addedNodes = Array.from(mutation.addedNodes);

          const hasRelevantNode = addedNodes.some((node) => {
            if (node.nodeType !== Node.ELEMENT_NODE) return false;

            if (
              node.matches &&
              (node.matches(".subscription-block") ||
                node.matches(".kadeso-subscription-placeholder"))
            ) {
              return true;
            }

            if (
              node.querySelector &&
              (node.querySelector(".subscription-block") ||
                node.querySelector(".kadeso-subscription-placeholder"))
            ) {
              return true;
            }

            return false;
          });

          if (hasRelevantNode) {
            relevantChange = true;
            break;
          }
        }
      }

      if (relevantChange) {
        const subscriptionBlock = document.querySelector(".subscription-block");
        const placeholder = document.querySelector(
          ".kadeso-subscription-placeholder"
        );

        if (subscriptionBlock && placeholder) {
          clearTimeout(kadesoInitTimer);
          setTimeout(initSubscription, 100);
        }
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: false,
    });

    observer.observe(document.head, {
      childList: true,
      subtree: false,
    });
  }

  let checkCount = 0;
  const periodicCheck = setInterval(() => {
    checkCount++;
    if (
      checkCount > 5 ||
      (window.enhancedKadesoInstance &&
        window.enhancedKadesoInstance.initialized)
    ) {
      clearInterval(periodicCheck);
      return;
    }

    const subscriptionBlock = document.querySelector(".subscription-block");
    const placeholder = document.querySelector(
      ".kadeso-subscription-placeholder"
    );

    if (
      subscriptionBlock &&
      placeholder &&
      (!window.enhancedKadesoInstance ||
        !window.enhancedKadesoInstance.initialized)
    ) {
      window.kadesoInitializing = false;
      kadesoRetryCount = 0;
      initSubscription();
    }
  }, 1000);
})();
